<template>
<div class="bounding-box">
	<div class="navbar">

		<div class="navbar-brand reveal" id="intro"> 

			<a href="/#">
				<img class="navbarItem" id="logo" src="@/assets/greo-logo-white.png"/>
			</a>

		</div>
		
		<Menu class="navbar-menu reveal" id="intro"/>

		<ul class="navbar-social reveal" id="intro">

			<li class="item" v-for="item in items" v-bind:key="item">
			<a :href="item.link" target="_blank">
				<img :id="item.id" :src="item.img"/>
			</a>
			</li>

		</ul>
	</div>
</div>
</template>

<script>
import { Slide } from 'vue-burger-menu';
import Menu from './Menu.vue';

export default {

  name: 'Navbar',
  components: {
	  Menu
  },
  data: () => ({ 
	items: [
		{ id: 'facebok', link: 'https://www.facebook.com/greoapp/', img: require('@/assets/icons/Facebook.svg') },
		{ id: 'twitter', link: 'https://twitter.com/getgreo', img: require('@/assets/icons/Twitter.svg') },
		{ id: 'instagram', link: 'https://www.instagram.com/getgreo/', img: require('@/assets/icons/Instagram.svg') }
	]
  }),
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

// MARK: - Constants
@mixin breakpoint1 { @media only screen and (min-width: 0px) { @content; } }
@mixin breakpoint2 { @media only screen and (min-width: 750px) { @content; } }
@mixin breakpoint3 { @media only screen and (min-width: 1024px) { @content; } }

$scaleTransitionCurve: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);


// MARK: - Structure

.bounding-box {
	width: 100%;
}

.navbar {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	height: 100%;
	width: 100%;
}

.navbar-brand, .navbar-social, .navbar-menu {
	display: flex;
	flex-direction: row;
	align-items: center;
	flex: 1;
}

// MARK: - Logo
.navbar-brand {
	justify-content: flex-start;
}


#logo {
	border-style: none;
	height: 2.75em;
	opacity: 0.75;

}

#logo:hover {
	opacity: 1;
	transform: scale(1.1);
	transition: $scaleTransitionCurve;
}


// MARK: - Social links
.navbar-social {
  list-style-type: none;

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex: 1;

  padding: 0;

  li {
	margin-right: calc(1em + 1vw);
  }

  li:last-child {
	margin-right: 0;
  }

  img {
	height: 1.5em;
	opacity: 0.75;
	transform: scale(1);
  }

  img:hover {
	opacity: 1;
	transform: scale(1.15);
	transition: $scaleTransitionCurve;
  }
}

.navbar-social {
	@include breakpoint1 {
		display: none;
	}
	
	@include breakpoint2 {
		display: flex;
	}
}

.navbar-menu {
	@include breakpoint1 {
		display: none;
	}

	@include breakpoint2 {
		display: none;
	}
	
	@include breakpoint3 {
		display: flex;
	}
}

</style>



// WEBPACK FOOTER //
// src/components/Intro/Navbar.vue